export default __webpack_public_path__ + "static/media/21.a4428989.jpg";